import {MARKER} from '../utils/constants.js';
import {noop} from '../utils/utils.js';

export default function log(visibility, interaction, measurements) {
    visibility.then(value => console.log(MARKER, value), noop); // eslint-disable-line no-console
    interaction.then(value => console.log(MARKER, value), noop); // eslint-disable-line no-console
    Promise.allSettled(measurements).then(results => {
        results
            .filter(({status}) => status === 'fulfilled')
            .forEach(({value}) => console.log(MARKER, value)); // eslint-disable-line no-console
    }, noop);
}
